// extracted by mini-css-extract-plugin
module.exports =  {"box":"campaignDeleteModal__box","wrapper":"campaignDeleteModal__wrapper"};